import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Main from "./components/Main";
import Upload from "./components/Upload";
import Login from "./components/Login";
import { useEffect, useState } from "react";
import logo from "../src/assets/logo.png";
import MainOnWork from "./components/MainOnWork";

function App() {
   const [token, setToken] = useState(null);

   useEffect(() => {
      setToken(localStorage.getItem("token"));
   }, []);

  return (
      <BrowserRouter>
         <Routes>
            <Route
               path="/upload"
               element={token ? <Upload /> : <Navigate to="/" />}
            />
            <Route exact path="/5s0ba0RZNkws" name="Demo" element={<Login />} />
            <Route path="/home" name="Home" element={<MainOnWork />} />
            <Route path="*" name="Home" element={<MainOnWork />} />
         </Routes>
      </BrowserRouter>
   );
}

export default App;
